export default {
  props: {
    cols: {
      default: 6,
    },
    amount: {
      default: 3,
    },
    shareIcon: {
      default: false,
    },
  },
};
